<template>
    <v-menu offset-y left>
        <v-btn v-slot:activator="{on}" fab small>
          <!-- <v-icon>person</v-icon> -->
          <v-avatar small pb-2>{{initials()}}</v-avatar>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex>User: {{name}}</v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex>Organization: {{orgName}} ({{orgId}})</v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex>Domain: {{orgDomain}}</v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex>Timezone: {{timezone}}</v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-btn text color="orange" @click="logout()">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    computed: {
        ...mapGetters('user', {
            name: 'getName',
            orgName: 'getOrgName',
            orgId: 'getOrgId',
            orgDomain: 'getOrgDomain',
            timezone: 'getOrgTimezone'
        })
    },
    data () {
      return {}
    },
    methods: {
      async logout() {
        await this.$store.dispatch('user/logout')
        this.$router.replace({ path: "/" })
      },
      initials() {
        if (!this.name) {
          return 'U'
        }
        let firstLetter = this.name[0].toUpperCase()
        let tokens = this.name.split(' ')
        if ((tokens.length > 1) && (tokens[1])) {
          return firstLetter + tokens[1][0].toUpperCase()
        }
        return firstLetter
      }
    }
  }
</script>
